import Env from '../../base/env'
import Channels from '../../base/channels'

class Launcher
{
    constructor()
    {
        if(Env.$launcher == null) return false
        // Dom
        this.view = Env.$launcher
        // Vars
        this.viewport = Env.framework.toolbox.getViewport()
        // Tweens
        this.tlIn = new TimelineLite()
        this.tlOut = new TimelineLite()
        // Preload
        this.imgsToPreload = []
        // Flags
        this.TOTAL_PRELOAD = this.imgsToPreload.length
        this.NO_INTRO = false
        this.LAUNCHED = false
        this.SPEED = 5
        // FNs
        this.setup()
    }


    completeIn()
    {
        setTimeout(() => {
            this.out()
        }, 600);
    }

    completeOut()
    {
        Env.$html.classList.add('ui--isReady')
        this.LAUNCHED = true
        Env.$master.removeChild(this.view)
    }

    destroy()
    {

    }

    noLaunch()
    {
        Env.$html.classList.add('ui--isReady')
        Env.$master.removeChild(this.view)
        setTimeout(() => {
            Channels.emit('launcher::exit')
            this.LAUNCHED = true
        }, 100);
    }

    out()
    {

        const getCurrentController = Env.framework.toolbox.getController()
        this.tlOut.add([
            TweenMax.fromTo(this.view , 1,
                {
                    autoAlpha : 1
                },
                {
                    autoAlpha : 0,
                    ease: Cubic.easeOut,
                    onStart: ()=>{
                        setTimeout(() => {
                            Channels.emit('launcher::exit')
                        }, 300);
                        setTimeout(() => {
                            Env.$html.classList.add('ui--isReady')
                        }, 900);
                    }
                }
            )
        ])
        this.tlOut.add(()=>{
            this.completeOut()
        })
    }

    preload()
    {
        var array = Object.values(manifestImg)
        // Create Img
        for(let i = 0; i < array.length; i++) {
            const img = document.createElement('img')
            img.setAttribute('src',array[i])
            this.imgsToPreload.push(img)
        }
    }

    setup()
    {
        Env.framework.toolbox.resetScroll()
        this.preload()
        if(this.NO_INTRO) {
            this.noLaunch()
        } else {
            setTimeout(() => {
                this.out()
            }, 150);

        }
    }

}

export default Launcher;